export default __webpack_public_path__ + "static/media/drop.1689e32f.svg";